module.exports = __webpack_public_path__ + "img/logo-green.d4d38bf7.svg";